import _ from 'lodash'

export default (apiMethods, endpoints) => ({

    login: (email, password) => {
        return apiMethods.post(endpoints.LOGIN_ENDPOINT, { email, password });
    },
    checkLogin: () => {
        return apiMethods.get(endpoints.LOGIN_CHECK_ENDPOINT);
    },
    logout: () => {
        return apiMethods.get(endpoints.LOGOUT_ENDPOINT);
    },
    registerStep1: (username, email, password, passwordRepeat, humanVerificationCode, moduleOptions) => {
        return apiMethods.post(endpoints.REGISTER_S1_ENDPOINT, { 
            username, email, password, passwordConfirmation: passwordRepeat, humanVerificationCode, moduleOptions });
    },
    registerStep2: (phone, profilePicture) => {
        const formdata = new FormData()
        if (phone)
            formdata.append('phone', phone)
        if (profilePicture)
            formdata.append('profilePicture', profilePicture)

        return apiMethods.post(endpoints.REGISTER_S2_ENDPOINT, formdata)
    },

    registerStep3: (subscriptions) => {
        return apiMethods.post(endpoints.REGISTER_S3_ENDPOINT, { subscriptions })
    },

    registerStep4: (step1, step2, step3, step4) => {
        const { phone, profilePicture } = step2
            , { username, email, password, passwordRepeat } = step1
            , { subscriptions } = step3
            , { companyName, cui, accountNumber, contactName, contactPhone, contactEmail } = step4
        const formdata = new FormData()
        if (phone)
            formdata.append('phone', phone)
        if (profilePicture)
            formdata.append('profilePicture', profilePicture)
        formdata.append('username', username)
        formdata.append('email', email)
        formdata.append('password', password)
        formdata.append('passwordConfirmation', passwordRepeat)
        subscriptions.filter(s => !!s.subscriptionId).forEach((sub, index) => {
            formdata.append(`subscriptions[${index}][subscriptionId]`, sub.subscriptionId)
            formdata.append(`subscriptions[${index}][domainId]`, sub.domainId)
        })

        if (companyName || accountNumber || cui) {
            formdata.append(`paymentDetails[accountNumber]`, accountNumber)
            formdata.append(`paymentDetails[companyName]`, companyName)
            formdata.append(`paymentDetails[CUI]`, cui)
        }
        if (contactName || contactPhone || contactEmail) {
            formdata.append(`contactPersons[name]`, contactName)
            formdata.append(`contactPersons[email]`, contactEmail)
            formdata.append(`contactPersons[phoneNumber]`, contactPhone)
        }

        return apiMethods.post(endpoints.REGISTER_S4_ENDPOINT, formdata)
    },
    finishTutorial: () => {
        return apiMethods.get(endpoints.FINISH_TUTORIAL_ENDPOINT)
    },
    updateUser: (data, isFormData) => {

        if (isFormData) {
            let formdata = new FormData();
            _.map(data, (field, key) => {
                if (field) formdata.append(key, field)
                return field
            })

            return apiMethods.put(endpoints.UPDATE_USER_ENDPOINT, formdata, {
                'Content-Type': 'multipart/form-data'
            })
        }

        return apiMethods.put(endpoints.UPDATE_USER_ENDPOINT, data)
    },
    updateUserProfilePicture: (profilePicture) => {
        let formdata = new FormData();
        formdata.append('profilePicture', profilePicture);

        return apiMethods.put(endpoints.UPDATE_USER_PHOTO_ENDPOINT, formdata, {
            'Content-Type': 'multipart/form-data'
        })
    },
    impersonate: (merchantId) => {
        return apiMethods.post(endpoints.IMPERSONATE_ENDPOINT, { id: merchantId });
    },
    deleteMyProfile: () => {
        return apiMethods.delete(endpoints.DELETE_MY_PROFILE_ENDPOINT);
    },
    resetPassword: (data) => {
        return apiMethods.post(endpoints.RESET_PASSWORD_ENDPOINT, data);
    },
    requestResetPassword: (email) => {
        return apiMethods.get(endpoints.REQUEST_RESET_PASSWORD_ENDPOINT + '/' + email)
    },
    resetPasswordToken: (data) => {
        return apiMethods.post(endpoints.RESET_PASSWORD_TOKEN_ENDPOINT, data)
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-user.js